import { render } from "./BugFormModal.vue?vue&type=template&id=3f443fe7&scoped=true&ts=true&lang=pug"
import script from "./BugFormModal.vue?vue&type=script&lang=ts"
export * from "./BugFormModal.vue?vue&type=script&lang=ts"

import "./BugFormModal.vue?vue&type=style&index=0&id=3f443fe7&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f443fe7"]])

export default __exports__